// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__20xls","actionsCol":"EnrolledClinics_actionsCol__2O0HA"};